import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import HeroSection from '../../components/HeroSection';
import { useAuthContext } from '@asgardeo/auth-react';
import { useEffect, useState } from 'react';

const Home = () => {
  const { state, getAccessToken } = useAuthContext();
  const [userToken, setUserToken] = useState('noToken');
  const [currentViewState, setCurrentViewState] = useState('upload');

  useEffect(() => {
    const fetchToken = async () => {
      if (state.isAuthenticated) {
        const accessToken = await getAccessToken();
        setUserToken(accessToken);
        sessionStorage.setItem('userToken', userToken);
      } else {
        setUserToken('noToken');
      }
    };
    fetchToken();
  }, [state.isAuthenticated, getAccessToken, userToken]);

  const handleViewStateChange = (viewState) => {
    setCurrentViewState(viewState);
  };

  return (
    <div className="h-screen flex flex-col bg-pl_bg_light_3 dark:bg-pl_bg_dark_1">
      <Header currentViewState={currentViewState} />
      <main className="flex-1 w-full mx-auto bg-pl_bg_light_3 dark:bg-pl_bg_dark_1 overflow-y-auto">
        <div className="w-full h-full">
          <HeroSection onViewStateChange={handleViewStateChange} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
